import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Select, Spin } from "antd";
import * as actions from "../../actions/index";
import './style.css';

const Option = Select.Option;

function CommunityTypes(props) {

    const { categories, loading } = props;

    useEffect(function () {
        props.getCommunityOrgTypes();
    }, []);

    function renderOptions() {

        if (!categories || categories.length === 0) {
            return null;
        }

        return categories.map(function (item) {
            return (
                <Option key={item.category_id} value={item.category_code}>
                    {item.category_name}
                </Option>
            );
        });
    }

    return (
        <div>
            {loading ?
                <Spin />
                :
                <Select
                    className="community-select"
                    style={{ width: "100%" }}
                    placeholder="Select Community Organization Type"
                    allowClear
                >
                    {renderOptions()}
                </Select>
            }
        </div>
    );
}

function mapStateToProps(state) {
    return {
        categories: state.communityOrgTypesReducer.categories,
        loading: state.communityOrgTypesReducer.loading
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CommunityTypes);


// WEBPACK FOOTER //
// ./src/components/ListandAdvancedSearch/CommunityTypes.js